import { Skeleton } from 'antd'
import { Rule } from 'antd/lib/form'

import { SubcontractorSummaryCaptureBlock as SubcontractorSummaryCaptureBlockType } from '../../types/blueprint'
import { CaptureSubcontractorSummary } from '../CustomBlocks/SubcontractorSummary/CaptureSubcontractorSummary'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import { useTemplateRenderer } from '@/context/templateRendererContext'
import { useAttendanceData } from '@/hooks/useAttendanceData'

type Props = {
  block: SubcontractorSummaryCaptureBlockType
  rules: Rule[]
}

export const SubcontractorSummaryCaptureBlock: React.FC<Props> = ({
  block,
  rules,
}) => {
  const { value, hourConfig } = block
  const { extraInfo, projectId } = useTemplateRenderer()

  const siteDiaryId = extraInfo.siteDiaryId as string

  const attendanceData = useAttendanceData(
    projectId,
    siteDiaryId,
    value,
    hourConfig,
    {
      includeAutomatedSignOns: false,
      manuallySuppliedSignOns: null,
      includeSubbieBreakdown: true,
      manuallySuppliedSubcontractors: null,
    }
  )

  const { loading, importedAttendance, projectSubcontractors } = attendanceData

  const initialValue = value?.subcontractorAttendances
    ? value
    : {
        ...importedAttendance,
        subcontractorAttendances: [],
      }

  if (loading) return <Skeleton />

  return (
    <CaptureBlockFormItem
      block={block}
      initialValue={initialValue}
      rules={rules}
    >
      <CaptureSubcontractorSummary
        projectSubcontractors={projectSubcontractors}
      />
    </CaptureBlockFormItem>
  )
}
